/* eslint-disable */
import Svg, {Circle, Line, Path, Rect} from 'react-native-svg';
import {colors} from '../../config/theme';
import {ICON_SHAPES} from './iconShapes';

const TAGS = {rect: Rect, path: Path, line: Line, circle: Circle};

// <AppIcon name="diesel" size={24} color={colors.primary} />
// name: 'benzine' | 'diesel' | 'electric' | 'lpg' | 'car'
// An unknown name (e.g. a new fuel type from the API) falls back to the pump.
const AppIcon = ({
  name,
  size = 24,
  color = colors.primary,
  strokeWidth = 1.8,
}) => {
  const shapes = ICON_SHAPES[name] || ICON_SHAPES.benzine;
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round">
      {shapes.map(([tag, props], i) => {
        const Shape = TAGS[tag];
        return <Shape key={i} {...props} />;
      })}
    </Svg>
  );
};

export default AppIcon;